import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { PosService } from "src/app/_services/posService";

@Component({
  selector: "app-proof-of-delivery-service",
  templateUrl: "./proof-of-delivery-service.component.html",
  styleUrls: ["./proof-of-delivery-service.component.scss"],
})
export class ProofOfDeliveryServiceComponent implements OnInit {
  searchTerm: string = "";
  responseData: any;
  isError: any;
  isEmpty = false;
  poNo: any;
  lineItems: any[] = [];
  selectedItems = [];
  loading = true;
  all = false;
  isSelected = false;
  displayName: any;
  page = 1;
  pageSize = 10;
  collectionSize: any;
  po: any;
  sessionExpired = false;
  errorMsg = "";
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  selectedOption = false;
  filterBy: any;
  impersonate;
  poData: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private posService: PosService,
    private authService: AuthService,
  ) {}

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  formatLineItemNo(value: string | number | null | undefined): string {
    if (value === null || value === undefined) {
      return "";
    }
    const s = String(value).trim();
    if (/^\d+$/.test(s)) {
      return String(parseInt(s, 10)).padStart(5, "0");
    }
    return s;
  }

  ngOnInit(): void {
    console.log("proof of delivery service");
    this.displayName = localStorage.getItem("displayName");
    this.poNo = this.route.snapshot.params["poNo"];
    if (localStorage.getItem("impersonation") === null || localStorage.getItem("impersonation") === "") {
      this.impersonate = "false";
    } else {
      this.impersonate = localStorage.getItem("impersonation");
    }

    this.loadPoLineItems();
  }

  loadPoLineItems(): void {
    this.loading = true;
    // First fetch the PO to get the ledger ID
    const poUserData = {
      sortConfig: {
        field: "updateTime",
        order: "desc",
      },
      pageSize: 50,
      pageNo: 1,
      filters: [
        {
          key: "docType",
          value: "PO",
        },
        {
          key: "docNoNumberOrString",
          value: this.poNo,
        },
        {
          key: "supplierCode",
          value: localStorage.getItem("vendorCode"),
        },
      ],
      sellercode: this.authService.getSellerCode(),
      isExport: false,
      linkFilters: [],
      isAP: true,
      isPOD: true,
    };

    this.posService.fetchPurchaseOrders(poUserData).subscribe(
      (res: any) => {
        console.log("fetch purchase orders for PO details");
        console.log(res, "res");

        if (res && res.code === 200 && res.data && res.data.list && res.data.list.length > 0) {
          const poData = res.data.list[0];
          this.poData = poData;
          console.log("PO Data:", poData);

          // Store PO details in localStorage
          localStorage.setItem("servCompanyCode", poData.cmpCode || "");
          localStorage.setItem("servPurchaseOrg", poData.purchaseOrg || "");
          localStorage.setItem("servDocType", poData.erpDocType || "");

          // Now fetch line items using the PO's ledger ID
          const lineItemsReq = {
            filters: [{ key: "ldgrId", value: poData._id }],
            pageNo: 1,
            isExport: true,
            sortConfig: {},
            isAP: true,
          };

          this.posService.fetchLineItems(lineItemsReq).subscribe(
            (lineItemsRes: any) => {
              console.log("fetch line items");
              console.log(lineItemsRes, "lineItemsRes");

              if (lineItemsRes && lineItemsRes.code === 200 && lineItemsRes.data && lineItemsRes.data.list) {
                this.lineItems = lineItemsRes.data.list.map((item: any) => ({
                  checked: false,
                  ...item,
                }));
                this.collectionSize = this.lineItems.length;
                this.refreshPo();
                this.loading = false;
              } else {
                this.isEmpty = true;
                this.loading = false;
              }
            },
            (error) => {
              console.error("Error fetching line items:", error);
              if (error.status === 401) {
                this.sessionExpired = true;
                this.errorMsg = error.error.msg;
              }
              this.loading = false;
            },
          );
        } else {
          this.isEmpty = true;
          this.loading = false;
        }
      },
      (error) => {
        console.error("Error fetching PO:", error);
        if (error.status === 401) {
          this.sessionExpired = true;
          this.errorMsg = error.error.msg;
        }
        this.loading = false;
      },
    );
  }

  reloadPoLineItems(): void {
    this.loadPoLineItems();
  }

  accountLogout() {
    const userData = {
      session: { sessionId: localStorage.getItem("eippSession") },
    };
    this.authService.logOut(userData).subscribe(
      (res) => {
        const responseData: any = res;
        if (responseData.status === "ok") {
          localStorage.clear();
          this.router.navigateByUrl("/");
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  checkAll(ev: any) {
    this.po.forEach((x: any) => {
      x.checked = ev.target.checked;
      this.onCheckboxChange(x.id - 1); // Manually call the handler for each checkbox
    });
  }

  isAllCheck() {
    console.log(this.po, "this.po");

    return this.po.every((p: any) => p.checked);
  }

  onCheckboxChange(index: number) {
    const isChecked = this.po[index].checked;

    if (isChecked) {
      // Check if the item is already in the selectedItems array
      const exists = this.selectedItems.some((item) => item.id === this.po[index].id);

      // Only add the item if it's not already in the array
      if (!exists) {
        this.selectedItems.push(this.po[index]);
      }
    } else {
      // Remove the item from selectedItems array if unchecked
      const selectedIndex = this.selectedItems.findIndex((item) => item.id === this.po[index].id);
      if (selectedIndex !== -1) {
        this.selectedItems.splice(selectedIndex, 1);
      }
    }

    this.isSelected = this.selectedItems.length !== 0;
  }

  sendPo(po = null) {
    if (po !== null) {
      console.log(po + " this is the null value");
    } else {
      console.log(this.po, "this.po");
      console.log(po, "po");

      if (this.selectedItems.length !== 0) {
        const items = this.selectedItems.map((r: any) => ({
          ...r,
          poNo: this.poNo,
          grnNo: "",
          supplierCode: this.poData.supplierCode,
          cmpCode: this.poData.cmpCode,
          purchaseOrg: this.poData.purchaseOrg,
          erpDocType: this.poData.erpDocType,
        }));

        localStorage.setItem("pods", JSON.stringify(items));
        this.router.navigate(["/submit-invoice", this.poNo]);
      }
    }
  }

  refreshPo() {
    let sortedLineItems = this.lineItems.sort((a, b) => (a.poLineNo > b.poLineNo ? 1 : -1));
    this.po = sortedLineItems
      .map((lineItem: any, i: any) => ({
        id: i + 1,
        ...lineItem,
        checked: this.selectedItems.some((selected: any) => selected.id === i + 1),
      }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  onFilter(option: any) {
    this.filterBy = option.target.value;
    console.log(this.filterBy + " option selected");
    this.selectedOption = true;
  }

  onSearch(event: KeyboardEvent) {
    this.searchTerm = (event.target as HTMLInputElement).value;
    if (this.searchTerm !== "") {
      if (this.filterBy === "itemDescription") {
        this.po = this.lineItems.filter((data) => (data.itemDescription as string).toLowerCase().includes(this.searchTerm.toLowerCase()));
      } else {
        this.po = this.lineItems.filter((data) => data.poLineNo.toString().toLowerCase().includes(this.searchTerm.toLowerCase()));
      }
    } else {
      this.po = this.lineItems;
    }
  }

  generalSearch(event: KeyboardEvent) {
    this.searchTerm = (event.target as HTMLInputElement).value;

    if (this.searchTerm !== "") {
      this.po = this.lineItems.filter(
        (data) => (data.itemDescription as string).toLowerCase().includes(this.searchTerm.toLowerCase()) || data.poLineNo.toString().toLowerCase().includes(this.searchTerm.toLowerCase()),
      );
    } else {
      this.po = this.lineItems;
    }
  }
}
